import { SpareStockStatusEnum } from "@gtpl/shared-models/common-models";

export class GetSpareStockDto {
    pch: string;
    customer: string;
    brand: string;
    hsncode: string;
    item: string;
    name: string;
    description: string;
    location: string;
    locationdescription: string;
    colour: string;
    lot: string;
    lotref1: string;
    lotref2: string;
    buyerdescription: string;
    remarks: string;
    uom: string;
    reciept: string;
    age: number;
    ageingrange: string;
    quantity: number;
    value: number;
    poNo: number;
    supplier: string;
    modeoftransport: string;
    status: SpareStockStatusEnum;
    id: number;
    warehouse: number;
    userName: string;
    filepath?: string;
    stockzone?: string;

    constructor(
        pch: string,
        customer: string,
        brand: string,
        hsncode: string,
        item: string,
        name: string,
        description: string,
        location: string,
        locationdescription: string,
        colour: string,
        lot: string,
        lotref1: string,
        lotref2: string,
        buyerdescription: string,
        remarks: string,
        uom: string,
        reciept: string,
        age: number,
        ageingrange: string,
        quantity: number,
        value: number,
        poNo: number,
        supplier: string,
        modeoftransport: string,
        status: SpareStockStatusEnum,
        id: number,
        warehouse: number,
        userName: string,
        filepath?: string,
        stockzone?: string,


    ) {
        this.pch = pch;
        this.customer = customer;
        this.brand = brand;
        this.hsncode = hsncode;
        this.item = item;
        this.name = name;
        this.description = description;
        this.location = location;
        this.locationdescription = locationdescription;
        this.colour = colour;
        this.lot = lot;
        this.lotref1 = lotref1;
        this.lotref2 = lotref2;
        this.buyerdescription = buyerdescription;
        this.remarks = remarks;
        this.uom = uom;
        this.reciept = reciept;
        this.age = age;
        this.ageingrange = ageingrange;
        this.quantity = quantity;
        this.value = value;
        this.poNo = poNo;
        this.supplier = supplier;
        this.modeoftransport = modeoftransport;
        this.status = status;
        this.id = id;
        this.warehouse = warehouse;
        this.userName = userName;
        this.filepath = filepath;
        this.stockzone = stockzone;
    }

}